export const SHEET_ARTICULOS = 'Articulos';
export const SHEET_FORMATOS = 'Formatos';
export const SHEET_PROVIDERS = 'Proveedores';
export const SHEET_INFO = 'Info Auxiliar (No Editar)';

export const ARTICULOS_COLUMNS = [
  'CODIGO ARTICULO',
  'IMAGEN PEQUEÑA',
  'ARTES FINALES',
  'NOMBRE',
  'CLUSTERS',
  'REGIONALIDAD',
  'MONTAJE',
  'ACTIVO',
  'CANTIDAD MINIMA',
  'PALABRAS CLAVES',
];

export const FORMATOS_COLUMNS = [
  'CODIGO ARTICULO',
  'CODIGO FORMATO',
  'FORMATO',
  'MATERIAL',
  'ACTIVO',
  'PERSONALIZADO',
];

export const PROVIDER_COLUMNS = ['CODIGO ARTICULO', 'CODIGO FORMATO', 'CODIGO', 'PROVEEDOR', 'PRECIO', 'ACTIVO'];

export const COLUMNS_TO_VARIABLE_NAME_ARTICLES = {
  'CODIGO ARTICULO': 'code',
  'IMAGEN PEQUEÑA': 'imglink',
  'ARTES FINALES': 'linkEditable',
  NOMBRE: 'name',
  CLUSTERS: 'centerType',
  REGIONALIDAD: 'regional',
  MONTAJE: 'isMontaje',
  ACTIVO: 'active',
  'CANTIDAD MINIMA': 'minQuantity',
  'PALABRAS CLAVES': 'tags',
};

export const COLUMNS_TO_VARIABLE_NAME_FORMATS = {
  'CODIGO ARTICULO': 'codeArticle',
  'CODIGO FORMATO': 'codeFormat',
  FORMATO: 'format',
  MATERIAL: 'materialName',
  ACTIVO: 'active',
  PERSONALIZADO: 'isCustom',
};

export const COLUMNS_TO_VARIABLE_NAME_PROVIDERS = {
  'CODIGO ARTICULO': 'codeArticle',
  'CODIGO FORMATO': 'codeFormat',
  CODIGO: 'code',
  PROVEEDOR: 'providerName',
  PRECIO: 'price',
  ACTIVO: 'active',
};

export const COLUMNS_TO_VARIABLE_NAME_PROVIDERS_T2 = {
  PROVEEDOR: 'providerName',
  'CODIGO ARIBA': 'providerCode',
  PRECIO: 'price',
};

export const VARIABLE_NAME_TO_COLUMN = Object.entries({
  ...COLUMNS_TO_VARIABLE_NAME_ARTICLES,
  ...COLUMNS_TO_VARIABLE_NAME_FORMATS,
  ...COLUMNS_TO_VARIABLE_NAME_PROVIDERS,
  ...COLUMNS_TO_VARIABLE_NAME_PROVIDERS_T2,
}).reduce((acc, [col, varName]) => {
  if (!acc[varName]) acc[varName] = col;
  return acc;
}, {});
